import { render } from "./ordentrabajoresultadoprocedimientoec.vue?vue&type=template&id=16bc4d82&scoped=true"
import script from "./ordentrabajoresultadoprocedimientoec.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadoprocedimientoec.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadoprocedimientoec.vue?vue&type=style&index=0&id=16bc4d82&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16bc4d82"]])

export default __exports__